import Accordion from '@components/Accordion';
import Column from '@components/Column';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useTermCategoryHistory from './hooks/useTermCategoryHistory';
import PolicyRow from './PolicyRow';

/**
 * 서비스 이용 약관
 * @constructor
 */
function Policies() {
    const { t } = useTranslation('accountSetting');
    const histories = useTermCategoryHistory();
    return (
        <Accordion title={t('policies.title')}>
            <Contents spacing={4}>
                {histories?.map((history) => (
                    <PolicyRow termCategory={history}
                        key={history.id} />
                ))}
            </Contents>
        </Accordion>
    );
}

const Contents = styled(Column)`
    padding: var(--spacing-2) 0 var(--spacing-4);
`;

export default Policies;
